import React from 'react'
import { Box, Paper } from '@mui/material'
import { useSingleResource } from '../../../api/singleQueries'
import { ProductType } from './types'
import { ProductGroup } from './ProductGroup'
import { ProductAssignable } from './ProductAssignable'
import { VanityUrl } from '../../vanity/VanityUrl'
import { ProductPlatformFeatures } from 'components/product_platform_features/ProductPlatformFeatures'

export function ProductSingleResource() {
  const { item } = useSingleResource<ProductType>()

  if (!item) return <Box>Loading...</Box>

  return <Product product={item} />
}

export function Product({ product }: { product: ProductType }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        maxWidth: '800px',
      }}
    >
      <Paper elevation={1} sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Box>
            <strong>
              <em>PRODUCT DETAILS</em>
            </strong>
          </Box>
          <Box>
            <strong>ID:</strong> {product.id}
          </Box>
          <Box>
            <strong>Title:</strong> {product.title}
          </Box>
          <Box>
            <strong>Partner:</strong> {product.partner?.name ?? 'None'}
          </Box>
        </Box>
      </Paper>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <ProductAssignable productId={product.id} />
        <ProductGroup productId={product.id} />
        <VanityUrl productId={product.id} allowDelete={true} />
        <ProductPlatformFeatures productId={product.id} />
      </Box>
    </Box>
  )
}
